/**
 * src/lib/sentry.js
 * Sentry error tracking initialisation for the portal.
 * Gracefully no-ops when REACT_APP_SENTRY_DSN is not set (dev / local).
 */

import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0
  });
}

/**
 * Set or clear the Sentry user context.
 * Call with user object on login/signup/session restore, or null on logout.
 */
export function setSentryUser(user) {
  if (!dsn) return;
  if (user) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.accountId,
      role: user.role
    });
  } else {
    Sentry.setUser(null);
  }
}

export default Sentry;
